import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'

export const checkoutAisleCampaignsEnabledAccessControl: DomainAccessControlConfig = [
  {
    minICPlatformVersion: ICPlatformVersion.r2025_04_0,
    restrictedBannersAllowed: true,
  },
]

export const checkoutBannerCampaignsEnabledAccessControl: DomainAccessControlConfig = [
  {
    featureToggles: [FeatureToggle.checkoutBannerEnabled],
    minICPlatformVersion: ICPlatformVersion.r2026_05_0,
    restrictedBannersAllowed: true,
  },
]

export const marketplaceCampaignCreateBlockedAccessControl: DomainAccessControlConfig = [
  {
    notFeatureToggles: [FeatureToggle.ippAdsMigrationPostLaunch],
    restrictedBannersAllowed: true,
  },
  {
    featureToggles: [FeatureToggle.allowIppMpCampaignCreation],
    restrictedBannersAllowed: true,
  },
  {
    warehouseFeatureToggles: [FeatureToggle.allowIppMpCampaignCreation],
    restrictedBannersAllowed: true,
  },
]
